/** Bildirim parametrelerinde indirme / dış URL tespiti */

const DOWNLOAD_PARAM_KEYS = new Set([
  'DownloadUrl',
  'DownloadLink',
  'Download',
  'ZipUrl',
  'ArchiveUrl',
  'Url',
]);

export function isExternalHttpUrl(value?: string | null): boolean {
  if (!value) return false;
  const trimmed = value.trim();
  return /^https?:\/\//i.test(trimmed);
}

export type NotificationParam = {
  key?: string | null;
  value?: string | null;
  target?: string | null;
};

/** Parametreden tıklanabilir dış indirme URL'si çıkarır */
export function resolveNotificationDownloadHref(param: NotificationParam): string | null {
  const key = param.key?.trim() || '';
  const target = param.target?.trim() || '';
  const value = param.value?.trim() || '';

  if (isExternalHttpUrl(target)) return target;
  if (DOWNLOAD_PARAM_KEYS.has(key) && isExternalHttpUrl(value)) return value;
  return null;
}

/** Bildirim satırındaki indirme hedefi (parametre veya notificationTarget) */
export function resolveNotificationExternalHref(notification: {
  notificationTarget?: string | null;
  parameters?: NotificationParam[] | null;
}): string | null {
  if (isExternalHttpUrl(notification.notificationTarget)) {
    return notification.notificationTarget!.trim();
  }
  const params = notification.parameters;
  if (!Array.isArray(params)) return null;
  for (const param of params) {
    const href = resolveNotificationDownloadHref(param);
    if (href) return href;
  }
  return null;
}

export function openNotificationHref(href: string): void {
  if (isExternalHttpUrl(href)) {
    window.open(href, '_blank', 'noopener,noreferrer');
    return;
  }
  const path = href.startsWith('/') ? href : `/${href}`;
  window.location.assign(path);
}
